// API Configuration for different environments
const API_CONFIG = {
  development: {
    baseURL: '/feeds', // Uses proxy in development
    domainPricing: '/feeds/domainpricing.php'
  },
  production: {
    baseURL: 'https://my.clubhosty.com/feeds', // Direct API URL in production
    domainPricing: 'https://my.clubhosty.com/feeds/domainpricing.php',
    // Fallback to local proxy if CORS issues
    domainPricingProxy: '/api/domain-pricing-proxy.php'
  }
};

// Detect environment
const isProduction = process.env.NODE_ENV === 'production';
const currentConfig = isProduction ? API_CONFIG.production : API_CONFIG.development;

// Export configuration
export const API_ENDPOINTS = {
  DOMAIN_PRICING: currentConfig.domainPricing,
  DOMAIN_PRICING_PROXY: currentConfig.domainPricingProxy || currentConfig.domainPricing,
  BASE_URL: currentConfig.baseURL
};

// Utility function to build API URL
export const buildApiUrl = (endpoint) => {
  return isProduction 
    ? `https://my.clubhosty.com${endpoint}`
    : endpoint;
};

// Utility function to get domain pricing URL with fallback
export const getDomainPricingUrl = (useProxy = false) => {
  if (isProduction && useProxy) {
    return API_ENDPOINTS.DOMAIN_PRICING_PROXY;
  }
  return API_ENDPOINTS.DOMAIN_PRICING;
};

export default currentConfig;
